import { Outlet } from 'react-router-dom';
import Header from './Header';
import MobileNavbar from './MobileNavbar';
import Sidebar from './Sidebar';
import SearchOverlay from './SearchOverlay';
import Footer from './Footer';
import RegisterToast from './RegisterToast';
import styles from '../App.module.css';

const Layout = () => {
  return (
    <div className={styles.appLayout}>
      <Header />
      <SearchOverlay />
      <Sidebar />
      <RegisterToast />

      <main className={styles.mainContent}>
        <Outlet />
      </main>

      <MobileNavbar />
      <Footer />
    </div>
  );
};

export default Layout;
